import React from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { fadeUp, displaySection, kicker, sectionWrap, sectionInner } from './shared';

const FAQS = [
  {
    q: 'What does the makeover include?',
    a: 'The package includes r\u00e9sum\u00e9 makeover options, LinkedIn profile analysis and completely rewritten sections, peer benchmarking reports, and tools to create LinkedIn posts.',
  },
  {
    q: 'Is this a subscription?',
    a: 'No. \u20b9999 is a one-time payment for 15-day access, with no auto-renewal.',
  },
  {
    q: 'How do I get started after payment?',
    a: 'You\u2019ll receive a login link by email. Open your dashboard and upload your LinkedIn profile PDF to begin.',
  },
  {
    q: 'Do I need to share my LinkedIn password?',
    a: 'No. The analysis uses your uploaded LinkedIn profile PDF. You can apply the suggested changes yourself.',
  },
  {
    q: 'Will someone personally review my profile?',
    a: 'The offer combines AI with expert-curated guidance. It does not include an individual expert review unless that service is explicitly offered in your plan.',
  },
  {
    q: 'Will the makeover guarantee interviews or a job?',
    a: 'No service can guarantee hiring outcomes. The makeover helps you present your experience more clearly and strengthen your r\u00e9sum\u00e9 and LinkedIn profile.',
  },
  {
    q: 'Which r\u00e9sum\u00e9 design should I choose?',
    a: 'Choose the format that suits your target role and industry. Executive offers a formal presentation, Creative adds visual personality, and Tech provides a structured option for technical profiles.',
  },
];

export const FAQSection = () => (
  <section className={sectionWrap} aria-label="Frequently asked questions" id="faq">
    <div className={sectionInner}>
      <motion.div {...fadeUp} className="mb-12 max-w-3xl">
        <p className={kicker}>Common questions</p>
        <h2 className={`${displaySection} mt-4 text-4xl sm:text-5xl lg:text-6xl`}>
          Answers before checkout.<br /><span className="text-muted-foreground">No marketing spin.</span>
        </h2>
      </motion.div>
      <Accordion type="single" collapsible className="max-w-3xl divide-y divide-border/60 border-t border-b border-border/60" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-0">
            <AccordionTrigger className="py-5 text-left text-base sm:text-lg font-semibold tracking-[-0.01em] hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 -mt-1 text-sm sm:text-base text-muted-foreground leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
